import { useEffect, useRef } from 'react';

export const useObserver = (
    observed,
    options = { threshold: 0.1, onlyOnce: true },
    cb = () => {} // memoize this our you will be haunted by spooky ghosts
) => {
    const onlyOnce = useRef(options.onlyOnce);

    const optionsRef = useRef(
        Object.keys(options)
            .filter((o) => ['threshold', 'rootMargin', 'root'].includes(o))
            .reduce((prev, curr) => {
                prev[curr] = options[curr];
                return prev;
            }, {})
    );

    useEffect(() => {
        let calls = 0;
        const observer = window.IntersectionObserver
            ? new window.IntersectionObserver(
                  ([entry]) => {
                      if (onlyOnce.current && calls > 0) {
                          return;
                      }

                      if (entry.intersectionRatio > 0) {
                          cb();
                          calls = calls + 1;
                      }
                  },
                  { ...optionsRef.current }
              )
            : null;

        if (observer && observed.current) {
            observer.observe(observed.current);
        }
        return () => observer.disconnect();
    }, [cb, observed]);
};
